const REQUEST_PAGE = "REQUEST_PAGE";
const RECEIVE_PAGE = "RECEIVE_PAGE";
const REQUEST_PAGED_PAGES = "REQUEST_PAGED_PAGES";
const RECEIVE_PAGED_PAGES = "RECEIVE_PAGED_PAGES";

export { REQUEST_PAGE, RECEIVE_PAGE, REQUEST_PAGED_PAGES, RECEIVE_PAGED_PAGES };



// WEBPACK FOOTER //
// ./src/actions/page/page.actions.js